"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateExpressionVerbParser = void 0;
const appendAttributePath_js_1 = require("../../../../schema/actions/utils/appendAttributePath.js");
const isNumber_js_1 = require("../../../../utils/validation/isNumber.js");
const isString_js_1 = require("../../../../utils/validation/isString.js");
const index_js_1 = require("../symbols/index.js");
class UpdateExpressionVerbParser {
    constructor(schema, verbPrefix, id = '') {
        this.resetExpression = (initialStr = '') => {
            this.expression = initialStr;
        };
        this.appendAttributePath = (attributePath, options = {}) => (0, appendAttributePath_js_1.appendAttributePath)(this, attributePath, options);
        this.appendAttributeValue = (_, attributeValue) => {
            const expressionAttributeValueIndex = this.expressionAttributeValues.push(attributeValue);
            this.appendToExpression(`:${this.expressionAttributePrefix}${expressionAttributeValueIndex}`);
        };
        this.beginNewInstruction = () => {
            if (this.expression !== '') {
                this.appendToExpression(', ');
            }
        };
        this.appendValidAttributePath = (validAttributePath) => {
            validAttributePath.forEach((pathPart, index) => {
                if ((0, isString_js_1.isString)(pathPart)) {
                    let pathPartIndex = this.expressionAttributeNames.findIndex(value => value === pathPart);
                    if (pathPartIndex !== -1) {
                        pathPartIndex += 1;
                    }
                    else {
                        pathPartIndex = this.expressionAttributeNames.push(pathPart);
                    }
                    if (index > 0) {
                        this.appendToExpression('.');
                    }
                    this.appendToExpression(`#${this.expressionAttributePrefix}${pathPartIndex}`);
                }
                if ((0, isNumber_js_1.isNumber)(pathPart)) {
                    this.appendToExpression(`[${pathPart}]`);
                }
            });
        };
        this.appendValidAttributeValue = (validAttributeValue) => {
            if ((0, index_js_1.isGetting)(validAttributeValue)) {
                // TODO: Fix this cast
                const [expression, fallback] = validAttributeValue[index_js_1.$GET];
                if (fallback === undefined) {
                    this.appendAttributePath(expression);
                    return;
                }
                if (fallback !== undefined) {
                    this.appendToExpression('if_not_exists(');
                    this.appendAttributePath(expression);
                    this.appendToExpression(', ');
                    this.appendValidAttributeValue(fallback);
                    this.appendToExpression(')');
                    return;
                }
            }
            const expressionAttributeValueIndex = this.expressionAttributeValues.push(validAttributeValue);
            this.appendToExpression(`:${this.expressionAttributePrefix}${expressionAttributeValueIndex}`);
        };
        this.appendToExpression = (conditionExpressionPart) => {
            this.expression += conditionExpressionPart;
        };
        /**
         * @debt refactor "factorize with other expressions"
         */
        this.toCommandOptions = () => {
            const ExpressionAttributeNames = {};
            this.expressionAttributeNames.forEach((expressionAttributeName, index) => {
                ExpressionAttributeNames[`#${this.expressionAttributePrefix}${index + 1}`] =
                    expressionAttributeName;
            });
            const ExpressionAttributeValues = {};
            this.expressionAttributeValues.forEach((expressionAttributeValue, index) => {
                ExpressionAttributeValues[`:${this.expressionAttributePrefix}${index + 1}`] =
                    expressionAttributeValue;
            });
            const UpdateExpression = this.expression;
            return {
                ExpressionAttributeNames,
                ExpressionAttributeValues,
                UpdateExpression
            };
        };
        this.clone = (schema) => {
            const clonedParser = new UpdateExpressionVerbParser(schema !== null && schema !== void 0 ? schema : this.schema, this.verbPrefix, this.id);
            clonedParser.expressionAttributeNames = [...this.expressionAttributeNames];
            clonedParser.expressionAttributeValues = [...this.expressionAttributeValues];
            clonedParser.expression = this.expression;
            return clonedParser;
        };
        this.schema = schema;
        this.verbPrefix = verbPrefix;
        this.expressionAttributePrefix = `${verbPrefix}${id}_`;
        this.expressionAttributeNames = [];
        this.expressionAttributeValues = [];
        this.expression = '';
        this.id = id;
    }
}
exports.UpdateExpressionVerbParser = UpdateExpressionVerbParser;
